import { render, staticRenderFns } from "./VideoIncidence.vue?vue&type=template&id=f0a98264"
import script from "./VideoIncidence.vue?vue&type=script&lang=js"
export * from "./VideoIncidence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports